export const environment = {
  production: false,
  apiUrl: 'https://webv-dl.visorciv.net/visor_api/api',
  // apiUrl: 'http://localhost:8088/api',
  claveBase: 'V1$0rC1vDat@la1ng@170225',
  tokenName: 'Token',
  platformValue: 'EXT',
  platformName: 'platform',
  contentType: 'Content-Type',
  contentTypeValue: 'application/json',
  apiKeyName: 'MAPREX_KEY',
  apiKeyValue: 'maprexKey123'
};
